module.exports = __webpack_public_path__ + "c5f0c142d52d25324bb20ba9bff8cf70.pdf";